var map = {
	"./CNY.png": 55528,
	"./EUR.png": 60654,
	"./HKD.png": 93090,
	"./KRW.png": 37004,
	"./PHP.png": 69603,
	"./THB.png": 69414,
	"./TWD.png": 13053,
	"./USD.png": 72325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1389;